<template>
    <div>
        申请发票
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        }
    }
</script>
<style scoped>
</style>